import { useSyncExternalStore } from 'react';
import { assetStore } from '@/media/assetStore';

/** Re-render when the photo cache changes (photos are outside the store). */
export function useAssetVersion() {
  return useSyncExternalStore(assetStore.subscribe, assetStore.getVersion, assetStore.getVersion);
}
